export default __webpack_public_path__ + "static/media/p8.b722cb22.JPG";